import useIsDesktop from 'hooks/useIsDesktop';
import React from 'react';
import ArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {
  Box, FormControlLabel, Stack, Typography,
} from '@mui/material';
import Price from 'components/Price';
import DietaryTags from 'components/DietaryTags';
import { optionsHasChildren } from '../utils';

function OptionRow({ option, children, ...props }) {
  const hasChildren = optionsHasChildren(option);
  const isDesktop = useIsDesktop();

  return (
    <FormControlLabel
      value={option.id}
      control={children}
      sx={{
        width: 'calc(100% + 11px)',
        flex: 1,
        mr: 0,
        alignItems: 'flex-start',
        '& .MuiButtonBase-root': {
          py: 0,
          px: 1,
        },
        '& .MuiFormControlLabel-label': {
          minWidth: 0,
          flex: 1,
          mr: 0,
          '& .MuiFormControlLabel-label': {
            width: '100%',
          },
        },
      }}
      label={(
        <Box display="flex" justifyContent="space-between" alignItems="baseline" gap={1} pt="2px">
          <Stack
            direction="row"
            alignItems="center"
            minWidth={0}
            flexWrap="wrap"
          >
            <Typography variant="label-md" noWrap={false} mr={1}>
              {option.title}
            </Typography>
            <DietaryTags
              tags={option.dietary_tags}
              wrap={isDesktop ? 'nowrap' : 'wrap'}
            />
          </Stack>

          <Stack direction="row" alignItems="center">
            {option.servingSize && (
              <Typography variant="body-caption" mr={2}>
                Serves
                {" "}
                {option.servingSize}
              </Typography>
            )}
            <Price
              price={option.price}
              discountedPrice={option.discountedPrice}
              showZero={!hasChildren}
              priceVariant="label-md"
              discountedPriceVariant="label-sm"
              horizontal
            />
            {
              hasChildren && (
                <ArrowRightIcon sx={{ ml: 0.5, mr: -1 }} />
              )
            }
          </Stack>
        </Box>
      )}
      {...props}
    />
  );
}

export default OptionRow;
